<template>
  <modal
    name="roulette"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    :classes="['v--modal', 'error-modal', 'roulette']"
    :width="730"
    :height="'auto'"
    :scrollable="true"
    :adaptive="true"
  >
    <div class="roulette-header">
      <span>
        {{ $t("roulette.giftFund") }}
        :</span
      >
      <ul class="roulette-prize-list">
        <li v-for="prize in prizes" class="roulette-prize-item">
          <img :src="prize.gift.image" :alt="prize.gift.name" />
        </li>
      </ul>
    </div>
    <div class="roulette-body">
      <div class="roulette-field" :class="{ open: showWheel }">
        <ul class="roulette-list">
          <li
            v-for="(field, index) in computedSectors"
            @click="toggleBet(index, field.betId)"
            class="roulette-item"
            :class="{
              choosen: field.betId,
              zero: index == 0,
              'roulette-item-load': field.load,
            }"
          >
            <div
              class="roulette-number"
              :class="{ red: red.indexOf(index) != -1 }"
            >
              <span>{{ field.number }}</span>
            </div>
            <div class="roulette-users-count">
              <div v-if="field.users.length != 0">{{ field.users.length }}</div>
            </div>
            <div v-if="field.users.length != 0" class="roulette-users">
              <ul
                class="roulette-users-list"
                :class="{ 'roulette-users-wide': field.users.length >= 3 }"
              >
                <li
                  v-for="(rouletteUser, index) in field.users"
                  v-if="index < 9"
                  class="roulette-users-item"
                >
                  <router-link
                    @click.native="$event.stopImmediatePropagation()"
                    :to="'/profile/' + rouletteUser.id"
                    :style="{
                      'background-image': rouletteUser.avatar
                        ? 'url(' + rouletteUser.avatar + ')'
                        : '',
                    }"
                    class="roulette-users-avatar"
                    :class="{ 'no-avatar': !rouletteUser.avatar }"
                  ></router-link>
                </li>
              </ul>
              <div v-if="field.users.length > 9" class="roulette-users-more">
                ещё {{ field.users.length - 9 }}
                {{
                  declineNouns(field.users.length - 9, [
                    "человек",
                    "человека",
                    "человек",
                  ])
                }}
              </div>
            </div>
          </li>
        </ul>
        <div class="roulette-wheel-wrapper" :class="{ open: showWheel }">
          <div class="roulette-wheel wheel">
            <ul ref="wheel" class="wheel-list">
              <li v-for="sector in consts.wheel" class="wheel-item"></li>
            </ul>
            <div class="wheel-arrow">
              <span>{{ winNumber }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="roulette-header-mobile">
      <span>
        {{ $t("roulette.giftFund") }}
        :</span
      >
      <ul class="roulette-prize-list">
        <li v-for="prize in prizes" class="roulette-prize-item">
          <img :src="prize.gift.image" :alt="prize.gift.name" />
        </li>
      </ul>
    </div>

    <div v-if="!initIsEmpty('init') && init.costs" class="roulette-footer">
      <div class="roulette-footer-left">
        <div class="roulette-timer">
          <span v-if="showCountdown">
            {{ $t("roulette.beginningDrawing") }}
            <span class="timer">{{ timeRemain }}</span>
          </span>
        </div>
        <div v-if="confirmed" class="roulette-bet-wrapper">
          {{ $t("roulette.yourbetOn") }}:
          <span v-for="(bet, index) in myBets" class="bets">
            {{ bet }}<span v-if="index < myBets.length - 1">,</span>
          </span>
        </div>
        <div
          v-else-if="myBets.length > 0 && init.roulette_gifts.length"
          class="roulette-bet-wrapper"
        >
          {{ $t("roulette.theCostYourBets") }}:
          <span class="roulette-price">{{
            myBets.length -
              init.roulette_gifts[init.roulette_gifts.length - 1] >=
            0
              ? (myBets.length -
                  init.roulette_gifts[init.roulette_gifts.length - 1]) *
                betPrice
              : 0
          }}</span>
        </div>
        <div v-else-if="myBets.length > 0" class="roulette-bet-wrapper">
          {{ $t("roulette.theCostYourBets") }}:
          <span class="roulette-price">{{ myBets.length * betPrice }}</span>
        </div>
        <div
          v-else-if="init.roulette_gifts.length"
          class="roulette-bet-wrapper"
        >
          {{ $t("roulette.giftRates") }}:
          <span class="bets">{{
            init.roulette_gifts[init.roulette_gifts.length - 1]
          }}</span>
        </div>
        <div v-else class="roulette-bet-wrapper">
          {{ $t("roulette.theCostOfRate") }}:
          <span class="roulette-price">{{ betPrice }}</span>
        </div>
      </div>
      <div class="roulette-footer-right">
        <div
          @click="toggleSound"
          class="roulette-sound"
          :class="sound ? 'sound-is-on' : 'sound-is-off'"
        ></div>
        <button v-if="buttonLoader" class="button button-loader"></button>
        <button
          v-else
          @click="confirmBet"
          :disabled="confirmed || !myBets.length"
          class="button"
        >
          <span v-if="confirmed"> {{ $t("roulette.theBetsPlaced") }}</span>
          <span v-else>{{ $t("roulette.confirm") }}</span>
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { declineNouns } from "@/mixins/declineNouns";
import { calcRouletteTimer } from "@/mixins/calcRouletteTimer";
import { checkScroll } from "@/mixins/checkScroll";
import { consts } from "@/consts";

export default {
  name: "Roulette",
  props: {
    i18n: Object,
  },
  mixins: [
    declineNouns,
    calcRouletteTimer,
    // TODO: https://dl.dropboxusercontent.com/s/cy2s62iqj7f9gpy/shot_200427_223855.png - время в рулетке
    checkScroll,
  ],
  data() {
    return {
      loader: true,
      consts: consts,
      sectors: [],
      confirmed: false,
      myBets: [],
      // TODO: перенести в стили
      red: [1, 7, 10, 16, 19, 25, 28, 34, 5, 14, 23, 32, 3, 9, 18, 21, 27, 36],
      buttonLoader: false,
      showWheel: false,
      angle: 9.72972972972973,
      duration: 6000,
      winNumber: "",
      showCountdown: true,
      nextPlay: null,
      timeRemain: null,
      interval: null,
      unregisterRouterGuard: null,
      // timingPlayed: false
    };
  },
  watch: {
    $route(to, from) {
      if (to != from) {
        this.$modal.hide("roulette");
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      roulette: "roulette/fetchRoulette",
      rouletteErrors: "roulette/errors",
      init: "init/fetchInit",
      initIsEmpty: "init/isEmpty",
      timeDelta: "init/fetchTimeDelta",
      prizes: "roulette/fetchRoulettePrizes",
      prizesIsEmpty: "roulette/isEmpty",
      sound: "roulette/fetchSound",
    }),
    computedSectors() {
      this.sectors = [];
      this.myBets = [];
      for (let i = 0; i < 37; i++) {
        this.sectors.push({
          number: i,
          betId: "",
          users: [],
          load: false,
        });
      }
      let bets = this.roulette;
      for (let i = 0; i < bets.length; i++) {
        this.sectors[bets[i].number].users.push({
          id: bets[i].user.id,
          name: bets[i].user.name,
          avatar: bets[i].user.avatar,
        });
        if (this.user.id == bets[i].user.id) {
          this.myBets.push(bets[i].number);
          this.sectors[bets[i].number].betId = bets[i].id;
          if (bets[i]["confirmed"] == 1) {
            this.confirmed = true;
          }
        }
      }
      if (this.myBets.length == 0) {
        this.confirmed = false;
      }
      return this.sectors;
    },
    betPrice() {
      let price = this.init.costs.roulette_bet_price;
      let arr = price.split(".");
      return arr[1] == "00" ? arr[0] : price;
    },
  },
  methods: {
    beforeOpen(event) {
      this.checkScroll();
      // this.timingPlayed = false;
      document
        .getElementsByTagName("body")[0]
        .classList.add("roulette-wrapper");
      this.nextPlay = event.params.nextPlay;

      this.getRoulette();

      if (this.prizesIsEmpty("prizes")) {
        this.getPrizes();
      }

      this.$store.watch(
        (state, getters) => getters["sockets/message"],
        (msg) => {
          if (msg.event) {
            switch (msg.event) {
              case "roulette_is_over":
                this.showCountdown = false;
                this.showWheel = true;
                this.nextPlay = msg.data.roulette_next * 1000 + this.timeDelta;
                setTimeout(() => {
                  this.animateWheel(msg.data.winning_number);
                }, 1000);
                setTimeout(() => {
                  this.showCountdown = true;
                  this.getPrizes();
                }, 8000);
                break;
              default:
                break;
            }
          }
        }
      );
      this.calcRouletteTimer();
      this.interval = setInterval(() => {
        this.calcRouletteTimer();
      }, 1000);
    },
    beforeClose() {
      // this.timingPlayed = true;
      document
        .getElementsByTagName("body")[0]
        .classList.remove("roulette-wrapper");
      if (document.querySelectorAll(".v--modal").length < 2) {
        document.getElementsByTagName("body")[0].classList.remove("scroll-fix");
      }
      clearInterval(this.interval);
    },
    getRoulette() {
      this.$store.dispatch("roulette/get");
    },
    getPrizes() {
      this.$store.dispatch("roulette/getPrizes");
    },
    toggleSound() {
      this.$store.dispatch("roulette/toggleSound");
    },
    toggleBet(number, betId) {
      if (this.confirmed) {
        this.$modal.show("dialog", {
          title: this.$t("roulette.unableChangeRate"),
          text: this.$t("roulette.confirmedCannotChangeThem"),
          buttons: [
            {
              title: this.$t("roulette.ok"),
            },
          ],
        });
        return;
      }
      this.sectors[number].load = true;
      let action, data;
      if (!this.sectors[number].betId) {
        if (this.myBets.length == 3) {
          this.$modal.show("dialog", {
            title: this.$t("roulette.unableAddBid"),
            text: this.$t("roulette.cannotBetMoreThanNumbers"),
            buttons: [
              {
                title: this.$t("roulette.ok"),
              },
            ],
          });
          return;
        }
        if (
          parseFloat((this.myBets.length + 1) * this.betPrice) >
          parseFloat(this.user.balance)
        ) {
          this.$modal.show("dialog", {
            title: this.$t("roulette.cantAddBid"),
            text: this.$t("roulette.notEnoughFunds"),
            buttons: [
              {
                title: this.$t("roulette.replenishBalance"),
                handler: () => {
                  this.$modal.hide("dialog");
                  this.$modal.show("balance-in");
                },
              },
              {
                title: this.$t("roulette.close"),
              },
            ],
          });
          return;
        }
        action = "roulette/makeBet";
        data = {
          number: number,
        };
      } else {
        action = "roulette/deleteBet";
        data = betId;
      }
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.sectors[number].load = false;
        })
        .catch((err) => {
          this.sectors[number].load = false;
        });
    },
    confirmBet() {
      if (this.myBets.length == 0 || this.buttonLoader) {
        return;
      }
      if (
        parseFloat(this.myBets.length * this.betPrice) >
        parseFloat(this.user.balance)
      ) {
        this.$modal.show("dialog", {
          title: this.$t("roulette.unableConfirmBets"),
          text: this.$t("roulette.notEnoughFunds"),
          buttons: [
            {
              title: this.$t("roulette.ok"),
            },
            {
              title: this.$t("roulette.refill"),
              handler: () => {
                this.$modal.show("balance-in");
              },
            },
          ],
        });
        return;
      }
      this.buttonLoader = true;
      this.$store
        .dispatch("roulette/confirmBet")
        .then(() => {
          this.$modal.show("dialog", {
            title: this.$t("roulette.success"),
            text: this.$t("roulette.stakesConfirmed"),
            buttons: [
              {
                title: this.$t("roulette.ok"),
              },
            ],
          });
          this.confirmed = true;
          this.buttonLoader = false;
          if (this.init.roulette_gifts.length) {
            this.$store.dispatch("init/removeRouletteGift");
          }
          this.$store.dispatch("init/setMyBets", true);
        })
        .catch(() => {
          this.buttonLoader = false;
        });
    },
    animateWheel(number) {
      if (document.querySelectorAll(".roulette").length && this.sound) {
        let soundEl = document.getElementById("spin-sound");
        if (soundEl /*&& this.sound*/) {
          let spinPromise = soundEl.play();
          if (spinPromise) {
            spinPromise
              .then(() => {
                return;
              })
              .catch(() => {
                return;
              });
          }
        }
      }

      let sector = this.consts.wheel.indexOf(number);
      let wheel = this.$refs.wheel;
      let spin = 2160 - sector * this.angle;

      if (!wheel) {
        this.showWheel = false;
        return;
      }

      wheel.style.WebkitTransition =
        "transform " + this.duration / 1000 + "s cubic-bezier(.37,.01,.21,.99)";
      wheel.style.MozTransition =
        "transform " + this.duration / 1000 + "s cubic-bezier(.37,.01,.21,.99)";
      wheel.style.MsTransition =
        "transform " + this.duration / 1000 + "s cubic-bezier(.37,.01,.21,.99)";
      wheel.style.OTransition =
        "transform " + this.duration / 1000 + "s cubic-bezier(.37,.01,.21,.99)";
      wheel.style.transition =
        "transform " + this.duration / 1000 + "s cubic-bezier(.37,.01,.21,.99)";
      wheel.style.transform = "rotate(" + spin + "deg)";

      let self = this;

      setTimeout(function () {
        wheel.style.WebkitTransition = "all 0s ease 0s";
        wheel.style.MozTransition = "all 0s ease 0s";
        wheel.style.MsTransition = "all 0s ease 0s";
        wheel.style.OTransition = "all 0s ease 0s";
        wheel.style.transition = "all 0s ease 0s";
        wheel.style.transform = "rotate(" + (spin - 2160) + "deg)";

        self.winNumber = number;
      }, this.duration);

      setTimeout(function () {
        self.showWheel = false;
        self.winNumber = "";
        self.confirmed = false;
        // self.timingPlayed = false;
        self.$store.dispatch("roulette/clear");
        self.myBets = [];
      }, this.duration + 3000);
    },
  },
};
</script>
